import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getLegalAndRegTextApi } from '../../redux/legal_and_regulator_text/legalAndRegulatorTextApiCalls';
import { useSelector } from 'react-redux';
import { State } from '../../redux/store';
import { useTranslation } from 'react-i18next';
import { ShowFrontEndContext } from './types';
import { formattedDate } from '../../functions/functions';
import ShowDataImage from './ShowDataImage';
import { LegalAndRegTextInterface } from '../LegalAndRegulatorText/types';
import { pageDirContext } from '../../App';

const LegalRegText: React.FC = () => {
  const { legalAndRegTexts } = useSelector((state: State) => state.legalAndRegTexts);

  const dispatch: any = useDispatch();

  // Fetch legal and regulatory texts on component mount
  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getLegalAndRegTextApi());
    };
    fetchAPIs();
  }, [dispatch]);

  const { t } = useTranslation();

  const { pageDir } = useContext(pageDirContext)

  const { LegalRegTextRef, showImage, setShowImage } = useContext(ShowFrontEndContext);
  const [selectedFile, setSelectedFile] = useState<any>("");

  return (
    <section className={`space-y-4 p-4 bg-white`} ref={LegalRegTextRef} dir={pageDir}>
      <div className="bg-gray-100 p-4 md:p-6 rounded-lg shadow-md mb-2">
        {/* Title */}
        <h1 className={`text-main font-bold text-xl md:text-2xl lg:text-3xl mb-4 border-main ${pageDir === 'rtl' ? "border-r-4 pr-3" : "border-l-4 pl-3"}`}>
          {t("Textes juridiques et réglementaires")}
        </h1>

        {/* Content */}
        <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h3 className="text-gray-700 text-base md:text-lg font-semibold mb-4">
            {t("L'Ordre National des Médecins Dentaires de Mauritanie rappelle à tous les praticiens que l'exercice de la profession est soumis aux règles déontologiques et réglementaires en vigueur.")}
          </h3>
          {/* Subtitle before list */}
          <p className="text-gray-700 text-sm md:text-base font-semibold mb-3">
            {t("Les obligations des médecins dentaires incluent notamment :")}
          </p>
          {/* List with icons ✅ */}
          <ul className="space-y-3 text-gray-600 text-sm md:text-base">
            <li className="flex items-start gap-2">
              <span className="text-main text-lg">✅</span>
              <span>{t("Le respect du secret professionnel et des droits des patients")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-main text-lg">✅</span>
              <span>{t("L'application des normes d'hygiène et de sécurité sanitaire")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-main text-lg">✅</span>
              <span>{t("L'interdiction de toute publicité ou promotion contraire à l'éthique")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-main text-lg">✅</span>
              <span>{t("La mise à jour régulière des connaissances médicales et techniques")}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-2">
        {legalAndRegTexts.map((legal: LegalAndRegTextInterface, index) => (
          <div
            className="group flex justify-between rounded-lg shadow p-4 border border-main hover:bg-main cursor-pointer"
            key={index}
            onClick={() => {
              setShowImage(!showImage);
              setSelectedFile(legal.image);
            }}
          >
            <b className="text-center md:text-xl md:mb-3">{legal.title}</b>
            <p className="text-gray-400 text-sm">{formattedDate(legal.createdAt)}</p>
          </div>
        ))}
        {showImage && (
          <ShowDataImage selectedFile={selectedFile} modal={showImage} toggle={() => setShowImage(!showImage)} />
        )}
      </div>
    </section>
  );
};

export default LegalRegText;
